<template lang="pug">
  div.block__content
    h2 {{$t('title')}}
    template(v-if="isInit")
      div.text-center.loader-wrapper
        circle-loader
    template(v-else)
      profile-update-required-crypto-notice(:cryptoaddress-available="cryptoaddressAvailable")
        div
          ul.tarnsfer_form
            li
              .form-step
                h2 {{$t('title_1')}}
                form.form(@submit.prevent.stop)
                  payout-form-group(:label="$t('Получатель')" :required="true")
                    div(style="width:370px")
                      prime-dropdown-accounts(:disabled="formDisabled" :accounts="filteredAccounts" v-model="model.values.account")
                      error-message-block(v-slot:errors attribute="account" :errors="model.errors")
            li
              .form-step
                h2 {{$t('title_2')}}
                form.form(@submit.prevent.stop)
                  payout-form-group(:label="$t('Адрес')" :required="true")
                    // div(style="width:370px")
                    dropdown-crypto-addresses(:addresses="model.addresses" v-model="model.selectedAddress" @update="onAddressSelected" :disabled="formDisabled")
                  payout-hint-panel-form-group
                    template {{$t('address_hint')}}

                  payout-form-group(:label="$t('Номер карты')" :required="true" :has-errors="model.errors.has('pan')")
                    payout-masked-input(v-model="model.values.pan" mask="DDDD DDDD DDDD DDDD DD" :disabled="formDisabled")
                    //input.form-control(type="text" :disabled="formDisabled" v-model='model.values.pan' v-mask="'#### #### #### #### ##'")
                    error-message-block(v-slot:errors attribute="pan" :errors="model.errors")


                  br
                  payout-form-group(:label="$t('Сумма')" :required="true" :has-errors="model.errors.has('amount')")
                    input-amount-currency(:disabled='formDisabled' v-model='model.values.amount' currency="RUR")
                    template(v-slot:hints)
                      payout-input-hint-block(:hint="' '")
                        i18n(tag="span" path="amount_hint")
                          template(v-slot:min) {{model.minimum|money('RUR')}}
                          template(v-slot:max) {{model.maximum|money('RUR')}}
                          template(v-slot:cur) RUR

                    error-message-block(v-slot:errors attribute="amount" :errors="model.errors")
                  payout-form-group(:label="$t('Получаете')")
                    estimate-qiwi-usd-amount(:amount="model.values.amount" v-slot="slotProps")
                      input-amount-currency(:disabled='true' :value="slotProps.result" currency="USDT")
                    payout-input-hint-block(:force-show="true")
                      div {{$t('result_amount_hint')}}
                      div {{$t('currency_rate_hint')}}
                br
                .text-center
                  button(:disabled="formDisabled" @click.prevent="submit").btn.btn-success {{$t('Перейти к оплате')}}
</template>

<script lang="ts">
import Vue from "vue";
import {Component} from "vue-property-decorator";
import {DepositUsdtCardtransferModel} from "@/views/pages/finance/deposit/usdt/deposit-usdt";
import DropdownCryptoAddresses from "@/components/forms/dropdown/DropdownCryptoAddresses.vue";
import PayoutFormGroup from "@/components/forms/payout/PayoutFormGroup.vue";
import PayoutHintPanelFormGroup from "@/components/forms/payout/hint/PayoutHintPanelFormGroup.vue";
import InputAmount from "@/components/forms/payout/legacy/InputAmount.vue";
import InputAmountCurrency from "@/components/forms/payout/legacy/InputAmountCurrency.vue";
import ErrorMessageBlock from "@/components/forms/payout/ErrorMessageBlock.vue";
import PayoutInputHintBlock from "@/components/forms/payout/PayoutInputHintBlock.vue";
import {MoneyFormatFilter} from "@/models/filters/money";
import CircleLoader from "@/components/loaders/CircleLoader.vue";
import ProfileUpdateRequiredCryptoNotice
  from "@/views/pages/finance/accounts/crypto/notice/ProfileUpdateRequiredCryptoNotice.vue";
import EstimateQiwiUsdAmount from "@/views/pages/finance/deposit/usdt/EstimateQiwiUsdAmount.vue";
import { VueMaskDirective } from 'v-mask';
import PayoutMaskedInput from "@/components/forms/payout/forms/inputs/PayoutMaskedInput.vue";
import PrimeDropdownAccounts from "@/components/forms/dropdown/PrimeDropdownAccounts.vue";

@Component({
  name: "DepositUsdtCardtransferPage",
  filters: {
    money: MoneyFormatFilter,
  },
  components: {
    PrimeDropdownAccounts,
    PayoutMaskedInput,
    EstimateQiwiUsdAmount,
    ProfileUpdateRequiredCryptoNotice,
    CircleLoader,
    PayoutInputHintBlock,
    ErrorMessageBlock,
    InputAmountCurrency,
    InputAmount,
    PayoutHintPanelFormGroup, PayoutFormGroup, DropdownCryptoAddresses},
  directives: {
    mask: VueMaskDirective,
  }
})
export default class DepositUsdtCardtransferPage extends Vue {
  model = new DepositUsdtCardtransferModel()

  onAddressSelected(address) {
    this.model.values.address = address ? address.address : '';
  }

  get isInit() {
    return this.model.initStatus.isLoading
  }

  mounted() {
   this.reloadModel()
  }

  get cryptoaddressAvailable() {
    return this.model.initStatus.isLoaded && this.model.options.avail
  }

  reloadModel() {
    this.model.loadModel().catch(err => {
      this.model.initStatus.loadStart()
      setTimeout(() => {
        this.reloadModel()
      }, 3000)
    })
  }

  get formDisabled() {
    return this.model.initStatus.isLoading
      || this.model.submitStatus.isLoading
  }

  get filteredAccounts() {
    return this.model.accounts
  }

  submit() {
    this.model.submit().then(({paymentUrl}) => {
      window.open(paymentUrl, 'DepositUsdtViaQiwiPage');
    })
  }
}
</script>

<style scoped lang="less">
.loader-wrapper {
  display: flex;
  justify-content: center;
  margin: 3em 0 1em 0;
}
</style>

<i18n>
{
  "en": {
    "title": "Deposit USDT (Trc20) account via Russian bank cards",
    "title_1": "Account for replenishment",
    "title_2": "Address for transfer",
    "Адрес": "Address",
    "address_hint": "You can choose any of yours address, it will be used for the deposit transaction.",
    "Перейти к оплате": "Proceed to payment",
    "Сумма": "Amount",
    "Получатель": "Beneficiary account",
    "amount_hint": "Amount from {min} to {max} {cur}. The amount must be whole.",
    "Получаете": "Result amount",
    "result_amount_hint": "Your account will be replenished with this amount.",
    "currency_rate_hint": "In the event of a change in the USD exchange rate, the total amount may be slightly adjusted."
  },
  "ru": {
    "result_amount_hint": "Эту сумму вы получите на счет.",
    "title": "Пополнение USDT (Trc20) счета картами РФ",
    "title_1": "Cчет для пополнения",
    "title_2": "Адрес для перевода",
    "address_hint": "Можете выбрать любой из ваших адресов, он будет использоваться для транзакции пополнения.",
    "amount_hint": "Сумма от {min} до {max} {cur}. Сумма должна быть целой без копеек.",
    "currency_rate_hint": "В случае изменения курса USD итоговая сумма может быть незначительно скорректирована."
  }
}
</i18n>
